import { gql } from '@apollo/client'

const UpdateTrack = gql`
    mutation UpdateTrack($trackId: ID!, $roomId: ID, $updates: TrackInput) {
        updateTrack(trackId: $trackId, roomId: $roomId, updates: $updates) {
            id
            album
            artist
            bitRate
            codec
            composer
            contributors {
                id
                username
            }
            created
            date
            duration
            files {
                bitRate
                duration
                key
                size
            }
            genre
            globalTags
            roomId
            size
            tags
            title
            track
            updated
            userId
            youtubeId
        }
    }    
`

export default UpdateTrack
